function setCookie(name, value, options) {
    const opts = {
        path: "/",
        ...options
    }

    if (navigator.cookieEnabled) { 
        const cookieName = encodeURIComponent(name);
        const cookieVal = encodeURIComponent(value);
        let cookieText = cookieName + "=" + cookieVal;

        if (opts.days && typeof opts.days === "number") {
            const data = new Date();
            data.setTime(data.getTime() + (opts.days * 24*60*60*1000));
            cookieText += "; expires=" + data.toUTCString();
        }

        if (opts.path) {
            cookieText += "; path=" + opts.path;
        }
        if (opts.domain) {
            cookieText += "; domain=" + opts.domain;
        }
        if (opts.secure) {
            cookieText += "; secure";
        }

        document.cookie = cookieText;
    }
}

function getCookie(name) {
    if (document.cookie !== "") {
        const cookies = document.cookie.split(/; */);

        for (let cookie of cookies) {
            const [ cookieName, cookieVal ] = cookie.split("="); 
            if (cookieName === decodeURIComponent(name)) {
                return decodeURIComponent(cookieVal);
            }
        }
    }

    return undefined;
}



if(jQuery('[data-cookie]').length){
    window.addEventListener('load', ()=> {
    
        const accept = document.querySelector('[data-accept]')
        const cookieBar =  document.querySelector('[data-cookie]')
    
        accept.addEventListener('click' , (e)=>{
            e.preventDefault();
            const cookie = getCookie('privacy');
                     
            if(cookie === undefined){ 
                setCookie("privacy", "1", { days: 30, path: "/" });
                cookieBar.remove();
            }
        })
    
        if(getCookie('privacy') !== undefined){
            cookieBar.remove()
        }else{
            cookieBar.style.opacity = 1
        }
    })
    
}


if(jQuery('#modalCatalog').length){

    setTimeout(function() {

        jQuery(document).ready(function(){
            if(getCookie('catalog') === undefined){
                setTimeout(()=>{
                    jQuery("#modalCatalog").modal('show');
                },5000)
            }
        });

        jQuery('#modalCatalog').on('hidden.bs.modal', function (e) {          
            if(getCookie('catalog') === undefined){ 
                setCookie("catalog", "1", { days: 0.20, path: "/" });
            }
        })

    }, 5000);
}

